import React from 'react';
import PropTypes from 'prop-types';

import DepositPayment from 'components/ClientProfile/Payment/Deposit/DepositPayment';
import PaymentIframe from 'components/ClientProfile/Payment/Deposit/PaymentIframe';

const DepositPaymentPage = ({
  paymentMethod,
  paymentMethods,
  paymentUrl,
  setPaymentMethod,
  setPaymentUrl,
}) => {
  if (!paymentMethod) {
    return null;
  }

  if (paymentUrl) {
    return (
      <PaymentIframe
        paymentMethod={paymentMethod}
        paymentUrl={paymentUrl}
        setPaymentUrl={setPaymentUrl}
      />
    );
  }

  return (
    <DepositPayment
      paymentMethod={paymentMethod}
      paymentMethods={paymentMethods}
      setPaymentMethod={setPaymentMethod}
      setPaymentUrl={setPaymentUrl}
    />
  );
};

DepositPaymentPage.propTypes = {
  paymentMethodData: PropTypes.object,
  paymentUrl: PropTypes.string,
  setPaymentUrl: PropTypes.func.isRequired,
};

export default DepositPaymentPage;
